<template lang="html">
	<div class="common-mar-b">
		<van-tabs>
			<van-tab v-for="(item, index) in types" :key="index">
				<div slot="title" @click="getThisTypeCourse(item.id)">
					{{item.type_name}}
				</div>
			</van-tab>
		</van-tabs>
		<van-row class="video-list">
			<van-col span="24">
				<van-pull-refresh v-model="isLoading" @refresh="onRefresh">
					<van-list v-model="loading" :finished="finished" @load="onLoad" finished-text="没有更多了" :immediate-check="immediateCheck">
						<div class="video-container">
							<div class="video-list-item" v-for="(item, index) in videos" :key="index" @click="goVideoDetail(item.id)">
								<div class="video-list-imgbox">
									<van-image class="video-list-image" fit="cover" :src="imgUrl+item.video_thumbnail_image" />
									<div class="video-list-itemZZ">
										<div class="fix video-list-zz-text">
											<div class="fl">{{item.video_browse_num}}观看</div>
											<div class="fr">共{{item.subsection_count}}节</div>
										</div>
									</div>
								</div>
								<div class="video-list-title">{{item.video_title}}</div>
							</div>
						</div>
					</van-list>
				</van-pull-refresh>
			</van-col>
		</van-row>
		<footer-nav></footer-nav>
	</div>
</template>

<script>
	import FooterNav from "../../components/footer.vue"
	import wxapi from '@/common/wxapi.js'
	export default{
		components:{
			FooterNav
		},
		data(){
			typeId: 0;
			return{
				imgUrl: 'http://sls.zhishen.net.cn', //图片拼接路径
				types: [], //视频分类
				videos: [] ,//视频列表
				isLoading: false, //控制下拉刷新的加载动画
				loading: false,//控制上拉加载的加载动画
				finished: false,//控制在页面往下移动到底部时是否调用接口获取数据
				totalPage: 0,
				pageNumber: 1,
				immediateCheck: false //是否在初始化时立即执行滚动位置检查
			}
		},
		created(){
			let that = this
			//授权登录
			if(localStorage.getItem('userId') == null){
				localStorage.setItem('beforeUrl', location.href.split('&')[0])
				that.$router.push({path: '/author'})
			}
			// 百度统计
			let _hmt = _hmt || [];
			(function() {
			  //每次执行前，先移除上次插入的代码
			  document.getElementById('baidu_tj') && document.getElementById('baidu_tj').remove();
			  let hm = document.createElement("script");
			  hm.src = "https://hm.baidu.com/hm.js?5bf14d717bf0afb01060aea203da42c2";
			  hm.id = "baidu_tj";
			  let s = document.getElementsByTagName("script")[0]; 
			  s.parentNode.insertBefore(hm, s);
			})();
			let formdata = new FormData();
			formdata.append('token', localStorage.getItem('token'));
			that.$axios.post('http://sls.zhishen.net.cn/api/video/videoIndex', formdata)
			.then(function (res) {
				that.types = res.data.video_type
				that.videos = res.data.video_list.video_list
				let option = {
					title: '读联',
					link: '',
					imgUrl: 'http://sl.zhishen.net.cn/static/images/logo.png',
					desc: '读联'
				}
				if (/from=[^&$?]{1,}(&|$)/.test(location.search) || /isappinstalled=[^&$?]{1,}(&|$)/.test(location.search)) {
					let newSearch = location.search.replace(/from=[^&$?]{1,}(&|$)/, '').replace(/isappinstalled=[^&$?]{1,}(&|$)/, '').replace(/&$|\?$/, '');
					let newUrl = location.origin + location.pathname + newSearch + location.hash;
					location.replace(newUrl);
					option.link = newUrl
					wxapi.wxRegister(option)
				}else{
					option.link = location.href.split('&')[0]
					wxapi.wxRegister(option)
				}
			})
			.catch(function (error) {
				console.log(error);
			});
			document.title = "视频"
		},
		methods:{
			//点击视频分类
			getThisTypeCourse(id){
				let that = this
				let formdata = new FormData();
				formdata.append('token', localStorage.getItem('token'));
				formdata.append('type_id', id);
				formdata.append('page', 0);
				that.typeId = id;
				that.$axios.post('http://sls.zhishen.net.cn/api/video/getVideoList', formdata)
				.then(function (res) {
					that.videos = res.data.video_list
				})
				.catch(function (error) {
					console.log(error);
				});
			},
			//点击今日视频详情
			goVideoDetail(id){
				window.location.href = this.login.pageUrl + '/videodetail?videoId=' + id;
			},
			//下拉刷新
			onRefresh() {
				let that = this
				setTimeout(() => {
					let formdata = new FormData();
					formdata.append('token', localStorage.getItem('token'));
					formdata.append('type_id', that.typeId);
					formdata.append('page', 0);
					that.$axios.post('http://sls.zhishen.net.cn/api/video/getVideoList', formdata)
					.then(function (res) {
						that.videos = res.data.video_list
					})
					.catch(function (error) {
						console.log(error);
					});
					that.isLoading = false;
				}, 500);
			},
			//上拉加载
			onLoad() {
				let that = this;
				setTimeout(() => {
					let formdata = new FormData();
					formdata.append('token', localStorage.getItem('token'));
					formdata.append('type_id', that.typeId);
					formdata.append('page', that.pageNumber + 1);
					that.$axios.post('http://sls.zhishen.net.cn/api/video/getVideoList', formdata).then(function (res) {
						that.totalPage = res.data.total_page
						if (that.pageNumber >= that.totalPage) {
							that.finished = true;
							that.loading = false;
						}else{
							that.videos = that.videos.concat(res.data.video_list)
							that.loading = false;
							that.pageNumber++;
						}
					}).catch(function (error) {
						console.log(error);
					})
				}, 500);
			}
		}
	}
</script>

<style lang="css" scoped>
	.video-list{padding-top: 4.27vw;}
	.video-list-item,.video-list-imgbox,.video-list-image,.video-list-itemZZ{width: 100%;}
	.video-list-imgbox,.video-list-image,.video-list-itemZZ{height: 42.67vw;}
	.video-list-imgbox{position: relative;}
	.video-list-itemZZ{background: url(../../../static/images/shipinzhezhao.png) no-repeat center;position: absolute;top: 0;left: 0;border-radius: 2.67vw;}
	.video-list-zz-text{width: calc(100% - 8vw);padding: 35.73vw 4vw 3.2vw 4vw;font-size: 3.74vw;line-height: 3.74vw;color: #fff;}
	.video-list-title{font-weight: bold;line-height: 4.5vw;margin-top: 4vw;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;}
	.video-list-item{margin-top: 8vw;}
	.video-container .video-list-item:first-child{margin-top: 0;}
</style>



// WEBPACK FOOTER //
// src/view/video/index.vue